import { IonButton, IonButtons, IonCol, IonContent, IonFooter, IonGrid, IonHeader, IonIcon, IonInput, IonItem, IonLabel, IonModal, IonRange, IonRow, IonTitle, IonToolbar } from "@ionic/react"
import { closeOutline } from "ionicons/icons"
import { useRef, useState } from "react"
import { secToHHMM, toSeconds } from "../../util/report-helper"
import { ReportEntry } from "../../models/reportModels"
import { QuillEditor } from "../../components"
import { Delta } from "quill/core"
import { isJsonString } from "../../util/helper"

import "./ReportBook.scss";

interface DayEntryDialogProps {
    isOpen: boolean,
    handleClose: () => void
    addCallback: (duration: string, activity: string) => void,
    entry?: ReportEntry,
    editCallback: (id: number, duration: string, activity: string) => void
}

const DayEntryDialog: React.FC<DayEntryDialogProps> = ({ isOpen, handleClose, addCallback, entry, editCallback }) => {
    const [range, setRange] = useState<number>(entry ? toSeconds(entry.duration) : 0)
    const [activity, setActivity] = useState<string | any[]>(entry ? entry.activity : "");
    const [isRequired, setIsRequired] = useState<boolean>();
    const quillRef = useRef<HTMLDivElement | null>(null);

    const handleRangeInputChange = (e: any) => {
        if (e.detail.value) {
            const hm = e.detail.value;
            const hma = hm.split(":");
            const seconds = hma[0] * 60 * 60 + hma[1] * 60;
            setRange(seconds)
        }
    }

    const handleConfirm = () => {
        // #region agent log
        fetch('http://127.0.0.1:7243/ingest/cd4dd974-7c53-4988-8ac4-c1c81baa8bb7',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'dayEntryDialog.tsx:35',message:'handleConfirm called - BEFORE processing',data:{activity:activity,activityType:typeof activity,activityLength:activity?.length,isArray:Array.isArray(activity),entry:entry?{id:entry.id,activity:entry.activity,activityType:typeof entry.activity}:null,range:range},timestamp:Date.now(),sessionId:'debug-session',runId:'post-fix',hypothesisId:'A'})}).catch(()=>{});
        // #endregion

        console.log(activity);

        // Fix: Wenn activity bereits ein String ist (z.B. beim Bearbeiten ohne Textänderung),
        // verwenden wir ihn direkt. Wenn es ein Array ist (vom QuillEditor), serialisieren wir es.
        let editorContent: string;
        if (typeof activity === 'string') {
            // activity ist bereits ein JSON-String, verwende ihn direkt
            editorContent = activity;
        } else if (Array.isArray(activity)) {
            // activity ist ein Array vom QuillEditor, serialisiere es
            editorContent = JSON.stringify(activity);
        } else {
            // Fallback: serialisiere was auch immer es ist
            editorContent = JSON.stringify(activity);
        }

        const formattedRange = secToHHMM(range);
        // Prüfe ob activity leer ist (String oder Array)
        const isEmpty = typeof activity === 'string' 
            ? activity === "" 
            : Array.isArray(activity) 
                ? activity.length === 0 || (activity.length === 1 && (activity[0] as any)?.insert === "\n")
                : !activity;
        
        if (!isEmpty) {
            if (entry) {
                editCallback(entry.id, formattedRange, editorContent)
            } else {
                addCallback(formattedRange, editorContent);
            }
            handleClose();
            setRange(0);
            setActivity("");
        } else {
            setIsRequired(true)
        }
    }
    
    const getDefaultValue = () => {
        if (entry && entry.activity) {
            if (isJsonString(entry.activity)) {
                return JSON.parse(entry.activity)
            } else {
                return new Delta().insert(entry.activity)
            }
        } else {
            return new Delta().insert("")
        }
    }

    const handleTextChange = (value) => {
        if(value !== "" && isRequired){
            setIsRequired(false)
        }
        setActivity(value)
    }

    return (
        <IonModal
            isOpen={isOpen}
            onDidDismiss={handleClose}
            key={entry?.id}
            className="dayEntryDialog"
        >
            <IonHeader>
                <IonToolbar>
                    <IonTitle>{entry ? "Eintrag bearbeiten" : "Eintrag hinzufügen"}</IonTitle>
                    <IonButtons slot="end">
                        <IonButton onClick={handleClose}>
                            <IonIcon icon={closeOutline} />
                        </IonButton>
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <IonContent>
                <IonGrid>
                    <IonRow>
                        <IonCol size="12">
                            <IonItem lines="none" className="dayEntryDialogItem">
                                <IonRange
                                    value={range}
                                    onIonInput={(e: any) => setRange(e.detail.value)}
                                    min={0}
                                    max={43200}
                                    step={300}
                                    aria-label="Dauer"
                                >
                                    <div slot="label">Dauer</div>
                                </IonRange>
                            </IonItem>
                            <IonItem className="dayEntryDialogItem">
                                <IonInput
                                    value={secToHHMM(range)}
                                    pattern="^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$"
                                    type="time"
                                    min="00:00"
                                    max="12:00"
                                    onIonChange={handleRangeInputChange}
                                    aria-label="Dauer"
                                />
                            </IonItem>
                        </IonCol>
                        <IonCol size="12">
                            <div style={{marginTop: 10}}>
                                <IonLabel style={{marginBottom: 4}}>Tätigkeit</IonLabel>
                                <QuillEditor
                                    ref={quillRef}
                                    onTextChange={handleTextChange}
                                    defaultValue={getDefaultValue()}
                                />
                            </div>
                            <div className="errorText" style={{ paddingLeft: 16 }}>{isRequired ? "Textfeld darf nicht leer sein." : ""}</div>
                        </IonCol>
                    </IonRow>
                </IonGrid>

            </IonContent>
            <IonFooter>
                <IonToolbar >
                    <IonButtons slot="end">
                        <IonButton onClick={handleClose}>
                            abbrechen
                        </IonButton>
                        <IonButton fill="solid" color="primary" onClick={handleConfirm}>speichern</IonButton>
                    </IonButtons>
                </IonToolbar>

            </IonFooter>
        </IonModal>
    )
}

export default DayEntryDialog;